import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.warningTypes;
export const highRiskSupplementWarningTypesSelector = (state: RootState) => getState(state).data;
export const highRiskSupplementWarningTypesIsLoadingSelector = (state: RootState) =>
  getState(state).isLoading;
export const highRiskSupplementWarningTypesIsReadySelector = (state: RootState) =>
  getState(state).isReady;
export const highRiskSupplementWarningTypesErrorSelector = (state: RootState) =>
  getState(state).error;
